import script from "./DownloadCustomerForecastModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DownloadCustomerForecastModal.vue?vue&type=script&lang=ts&setup=true"

import "./DownloadCustomerForecastModal.vue?vue&type=style&index=0&id=200f5e4a&lang=scss&scoped=true"
import "./DownloadCustomerForecastModal.vue?vue&type=style&index=1&id=200f5e4a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-200f5e4a"]])

export default __exports__